import React from "react";
import {Drawer,Input,Select,Button,Rate} from 'antd';
import {InfoCircleOutlined,CreditCardOutlined,FireOutlined,ToolOutlined,TagOutlined,CarOutlined,AppstoreOutlined,LineChartOutlined } from '@ant-design/icons';

const { Search } = Input;
const { Option } = Select;

function Settings(props) {

    return (
    	<Drawer
	        width={300}
	        title="Configuración"
	        placement="right"
	        closable={true}
	        onClose={()=>props.setVisible(false)}
	        open={props.visible}>
	      
	        <div className="m-setup-item" style={{background:"#E2F6FE",marginTop:"32px"}}>
	            <Rate className="m-item-rate" count={1} value={1} />
	            <Button type="link">Favoritos</Button>
	        </div>

	        <div className="m-setup-item">
	          <LineChartOutlined />
	          <Button type="link">Gráficas</Button>
	        </div>

	        <div className="m-setup-item">
	            <AppstoreOutlined />
	            <Button type="link">Todo</Button>
	        </div>

	         <div className="m-setup-item">
	            <CarOutlined />
	            <Button type="link">Autos Nuevos</Button>
	        </div>
	        <div className="m-setup-item">
	            <TagOutlined />
	            <Button type="link">Seminuevos</Button>
	        </div>
	        <div className="m-setup-item">
	            <ToolOutlined />
	            <Button type="link">Servicio</Button>
	        </div>
	        <div className="m-setup-item">
	            <FireOutlined /> 
	            <Button type="link">Laminado y pintura</Button>
	        </div>
	        <div className="m-setup-item">
	            <CreditCardOutlined />  
	            <Button type="link">Administración</Button>
	        </div>
	        <div className="m-setup-item">
	            <InfoCircleOutlined />
	            <Button type="link">Acerca de..</Button>
	        </div>
    </Drawer>

    );
}

export default Settings;

